import React from 'react';

import { Skeleton, Typography } from '@mui/material';

import CompetitorOfferOpportunitiesTooltip from './CompetitorOfferOpportunitiesTooltip';
import { SEARCHING_FROM_CELL_COUNTRIES } from './constants';
import { CompetitorOfferRow, formatShare } from './utils';

interface Props {
  row: CompetitorOfferRow;
}

export default function CompetitorOfferSearchingFromCell({ row }: Props) {
  const { gha } = row;
  if (gha.status === 'loading' && row.lePropertyIds.length) {
    return <Skeleton width={140} />;
  }
  if (gha.status !== 'loaded' || !gha.opportunities) {
    return null;
  }
  const { opportunities } = gha;

  return (
    <CompetitorOfferOpportunitiesTooltip
      hotelName={row.hotelName ?? row.externalPropertyId}
      opportunities={opportunities}
    >
      <Typography variant="body2" fontWeight="medium">
        {opportunities.topCountries
          .slice(0, SEARCHING_FROM_CELL_COUNTRIES)
          .map(
            (country) =>
              `${country.countryCode ?? 'Unknown'} ${formatShare(country.opportunities, opportunities.opportunities)}`,
          )
          .join(' · ')}
      </Typography>
    </CompetitorOfferOpportunitiesTooltip>
  );
}
